module.exports = __webpack_public_path__ + "static/media/cirtecLogoCropped.1473d688.png";